import { IHackathonResponse } from "api/hackathon";
import { useMemo } from "react";
import { getTzFormat } from "utils/dateUtils";

export const useTimezone = (hackathon?: IHackathonResponse) => {
  return useMemo(() => {
    return getTzFormat(hackathon?.essentials?.timeZone);
  }, [hackathon?.essentials?.timeZone]);
};
